module.exports = __webpack_public_path__ + "static/media/exterior2.2fc447a0.webp";